import React from 'react';
import StarRating from './StarRating';

const colorPalette = [
  'bg-primary-500',
  'bg-emerald-500',
  'bg-rose-500',
  'bg-amber-500',
  'bg-indigo-500',
  'bg-cyan-500',
  'bg-fuchsia-500',
  'bg-lime-500',
];

const getConsistentColor = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % colorPalette.length;
  return colorPalette[index];
};
const TestimonialCard = ({ testimonial }) => {

  const userInitials = testimonial?.name
    ? testimonial.name.split(' ').map((n) => n[0]).join('').toUpperCase()
    : 'U';

  const bgColor = getConsistentColor(testimonial.email || testimonial.name || userInitials
  );
  return (
    <div className="bg-white dark:bg-neutral-800 rounded-lg shadow-sm border border-neutral-200 dark:border-neutral-700 p-6 hover:shadow-md transition">
      <div className="flex items-center mb-4">
        <div className={`w-12 h-12 mr-3 rounded-full ${bgColor} flex items-center justify-center text-white text-xl font-semibold`}>
          {userInitials}
        </div>
        <div>
          <h4 className="font-medium text-neutral-900 dark:text-white">{testimonial.name}</h4>
          <p className="text-sm text-neutral-600 dark:text-neutral-400">{testimonial.role}</p>
        </div>
      </div>
      <div className="flex mb-3">
        <StarRating rating={testimonial.rating} />
      </div>
      <p className="text-neutral-600 dark:text-neutral-400 italic">"{testimonial.content}"</p>
    </div>
  );
};

export default TestimonialCard;